import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ExperienceTimeoutError } from './ExperienceTimeoutError';
function mergeAttributes(first, last) {
  if (first === undefined) {
    return last;
  }
  if (last === undefined) {
    return first;
  }
  return _objectSpread(_objectSpread({}, first), last);
}
export var Experience = /*#__PURE__*/function () {
  function Experience(_ref) {
    var name = _ref.name,
      id = _ref.id,
      timeout = _ref.timeout,
      _ref$startTime = _ref.startTime,
      startTime = _ref$startTime === void 0 ? window.performance.now() : _ref$startTime,
      attributes = _ref.attributes,
      onStart = _ref.onStart,
      onSuccess = _ref.onSuccess,
      onFailure = _ref.onFailure,
      onAbort = _ref.onAbort;
    _classCallCheck(this, Experience);
    _defineProperty(this, "_hasStopped", false);
    this.name = name;
    this.id = id;
    this.timeout = timeout;
    this.startTime = startTime;
    this.attributes = attributes;
    this.onSuccess = onSuccess;
    this.onFailure = onFailure;
    this.onAbort = onAbort;
    var startEvent = {
      action: 'taskStart',
      name: name,
      id: id,
      startTime: startTime,
      timeout: timeout,
      attributes: attributes
    };
    if (onStart) {
      this.onStop = onStart(startEvent);
    }
  }
  _createClass(Experience, [{
    key: "hasStopped",
    get: function get() {
      return this._hasStopped;
    }
  }, {
    key: "succeed",
    value: function succeed(attributes) {
      if (this._hasStopped) {
        return;
      }
      this.onSuccess && this.onSuccess();
      this.stop({
        action: 'taskSuccess',
        name: this.name,
        id: this.id,
        startTime: this.startTime,
        duration: this.getDuration(),
        attributes: mergeAttributes(this.attributes, attributes)
      });
    }
  }, {
    key: "fail",
    value: function fail(_ref2) {
      var error = _ref2.error,
        attributes = _ref2.attributes;
      if (this._hasStopped) {
        return;
      }
      this.onFailure && this.onFailure();
      this.stop({
        action: 'taskFail',
        name: this.name,
        id: this.id,
        startTime: this.startTime,
        duration: this.getDuration(),
        error: error,
        attributes: mergeAttributes(this.attributes, attributes)
      });
    }
  }, {
    key: "abort",
    value: function abort(_ref3) {
      var reason = _ref3.reason,
        attributes = _ref3.attributes,
        _ref3$checkForTimeout = _ref3.checkForTimeout,
        checkForTimeout = _ref3$checkForTimeout === void 0 ? true : _ref3$checkForTimeout;
      if (this._hasStopped) {
        return;
      }

      // Check if the experience should have failed due to timeout
      if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
        this.fail({
          attributes: attributes,
          error: new ExperienceTimeoutError("".concat(this.name, " failed to complete in ").concat(this.timeout, "ms"))
        });
        return;
      }
      this.onAbort && this.onAbort();
      this.stop({
        action: 'taskAbort',
        name: this.name,
        id: this.id,
        startTime: this.startTime,
        duration: this.getDuration(),
        reason: reason,
        checkForTimeout: checkForTimeout,
        attributes: mergeAttributes(this.attributes, attributes)
      });
    }
  }, {
    key: "stopOn",
    value: function stopOn(event) {
      if (!event) {
        return;
      }
      if (event.action === 'taskSuccess') {
        this.succeed();
      } else if (event.action === 'taskAbort') {
        this.abort({
          reason: event.reason,
          checkForTimeout: event.checkForTimeout
        });
      } else if (event.action === 'taskFail') {
        this.fail({
          error: event.error
        });
      }
    }
  }, {
    key: "stop",
    value: function stop(event) {
      this._hasStopped = true;
      if (this.onStop) {
        this.onStop(event);
      }
    }
  }, {
    key: "getDuration",
    value: function getDuration() {
      return Math.round(window.performance.now() - this.startTime);
    }
  }]);
  return Experience;
}();